import React, { useState } from "react";
import { Button, Col, Container, Form } from "react-bootstrap";
import { Banner } from "../organizacion";

// Formulario para crear nuevos externos, los props se pasan por los componentes wrappers de cada organizacion
export const AgregarExterno = ({ post, familiaURL, name, logo, edit = {}, put, familia, apaga, recarga }) => {

    const [data, setData] = useState({
        name: edit.name,
        firstSurname: edit.firstSurname,
        secondSurname: edit.secondSurname,
        email: edit.email,
        familia: edit.familia ? edit.familia : familia,
        id: edit.id,
    })

    // Función para hacer el post o el put
    const externoAdd = (event) => {
        event.preventDefault()
        const fn = async () => {
            if (edit?.name) {
                await put(data)

            } else {
                await post(data)
            }
            apaga(false, "80%")
            recarga()
        };

        fn()
    }

    // cancelar y volver atrás
    const externoCancelar = (event) => {
        event.preventDefault()
        apaga(false, "80%")
    }

    return (
        <React.Fragment>
            <Container className="my-5">
                <Banner name={name} logo={logo} />
                <Form onSubmit={externoAdd} className="border rounded p-4" id="MyForm" autoComplete="off">
                    <header className="input-group-text mt-1"><strong>{edit.name ? 'Editar responsable externo' : 'Añadir responsable externo'}</strong></header>
                    <Form.Row>
                        <small className="mb-3">
                            Los campos con un <b>*</b> deben de ser rellenados.
                        </small>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Nombre *</Form.Label>
                            <Form.Control required type="text" name="name" maxLength="45" autoComplete="nope"
                                value={data.name} onChange={e => {
                                    setData({ ...data, name: e.target.value })
                                }} />
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Primer Apellido *</Form.Label>
                            <Form.Control required type="text" name="firstSurname" maxLength="60"
                                autoComplete="nope"
                                value={data.firstSurname} onChange={e => {
                                    setData({ ...data, firstSurname: e.target.value })
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Segundo Apellido</Form.Label>
                            <Form.Control type="text" maxLength="60" name="secondSurname" autoComplete="nope"
                                value={data.secondSurname} onChange={e => {
                                    setData({ ...data, secondSurname: e.target.value })
                                }} />
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name="email" maxLength="320" autoComplete="nope"
                                value={data.email} onChange={e => {
                                    setData({ ...data, email: e.target.value })
                                }} />
                        </Form.Group>
                    </Form.Row>

                    <Button variant="outline-primary" type="submit" className="my-3">
                        {edit.name ? 'Guardar' : 'Añadir'}
                    </Button>
                    <Button variant="outline-danger" onClick={externoCancelar} className="ml-3">
                        Cancelar
                    </Button>

                </Form>

            </Container>

        </React.Fragment>
    );
}
